import { useEffect } from "react";

export default function SeoManager({ title, description, canonical, lang }) {
  useEffect(() => {
    // 1. Title
    if (title) {
      document.title = title;
    }

    // 2. HTML lang
    if (lang) {
      document.documentElement.lang = lang;
    }

    // 3. Meta Description
    if (description) {
      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        metaDesc.setAttribute("content", description);
        document.head.appendChild(metaDesc);
      } else {
        metaDesc.setAttribute("content", description);
      }
    }

    // 4. Canonical Link
    if (canonical) {
      let canonicalLink = document.querySelector("link[rel='canonical']");
      if (!canonicalLink) {
        canonicalLink = document.createElement("link");
        canonicalLink.setAttribute("rel", "canonical");
        canonicalLink.setAttribute("href", canonical);
        document.head.appendChild(canonicalLink);
      } else {
        canonicalLink.setAttribute("href", canonical);
      }
    }
  }, [title, description, canonical, lang]);

  return null;
}
